import React, { useState } from "react";
import {
  Alert,
  Button,
  Card,
  Col,
  Container,
  Form,
  Row,
} from "react-bootstrap";
import { useHistory } from "react-router-dom";
import {
  cambiarMiPassword,
} from "../helpers/rutaUsuarios";

export default function CambiarPassword() {
  const history = useHistory();

  const [actual, setActual] = useState("");
  const [nueva, setNueva] = useState("");
  const [repetida, setRepetida] =
    useState("");
  const [error, setError] = useState("");
  const [guardando, setGuardando] =
    useState(false);

  const salir = () => {
    [
      "token",
      "id",
      "usuario",
      "user",
      "userDisplay",
      "authToken",
      "jwt",
    ].forEach((key) =>
      localStorage.removeItem(key)
    );

    history.replace("/login");
  };

  const guardar = async (event) => {
    event.preventDefault();
    setError("");

    if (nueva.length < 8) {
      setError(
        "La nueva contraseña debe tener al menos 8 caracteres."
      );
      return;
    }

    if (nueva !== repetida) {
      setError(
        "Las nuevas contraseñas no coinciden."
      );
      return;
    }

    if (actual === nueva) {
      setError(
        "La nueva contraseña debe ser diferente de la provisoria."
      );
      return;
    }

    setGuardando(true);

    const respuesta =
      await cambiarMiPassword(actual, nueva);

    setGuardando(false);

    if (!respuesta?.ok) {
      setError(
        respuesta?.err?.message ||
          "No se pudo cambiar la contraseña."
      );
      return;
    }

    window.alert(
      "Contraseña actualizada. Ingrese nuevamente con su nueva clave."
    );

    salir();
  };

  return (
    <Container className="py-5">
      <Row className="justify-content-center">
        <Col xs={12} md={7} lg={5}>
          <Card className="shadow-sm border-0">
            <Card.Body className="p-4 p-md-5">
              <div className="text-primary small fw-bold text-uppercase mb-2">
                Seguridad
              </div>

              <h2 className="mb-2">
                Cambiar contraseña
              </h2>

              <p className="text-muted mb-4">
                La clave recibida es provisoria.
                Para continuar debe elegir una
                nueva.
              </p>

              {error && (
                <Alert variant="danger">
                  {error}
                </Alert>
              )}

              <Form onSubmit={guardar}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Contraseña provisoria
                  </Form.Label>

                  <Form.Control
                    type="password"
                    required
                    autoFocus
                    value={actual}
                    onChange={(event) =>
                      setActual(event.target.value)
                    }
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>
                    Nueva contraseña
                  </Form.Label>

                  <Form.Control
                    type="password"
                    required
                    minLength={8}
                    value={nueva}
                    onChange={(event) =>
                      setNueva(event.target.value)
                    }
                  />

                  <Form.Text className="text-muted">
                    Utilice al menos 8 caracteres.
                  </Form.Text>
                </Form.Group>

                <Form.Group className="mb-4">
                  <Form.Label>
                    Repetir nueva contraseña
                  </Form.Label>

                  <Form.Control
                    type="password"
                    required
                    minLength={8}
                    value={repetida}
                    onChange={(event) =>
                      setRepetida(
                        event.target.value
                      )
                    }
                  />
                </Form.Group>

                <div className="d-grid gap-2">
                  <Button
                    type="submit"
                    disabled={guardando}
                  >
                    {guardando
                      ? "Guardando…"
                      : "Guardar nueva contraseña"}
                  </Button>

                  <Button
                    type="button"
                    variant="outline-secondary"
                    onClick={salir}
                  >
                    Cancelar y salir
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}